<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex xs12 sm12 lg12>
        <div class="headline green--text font-weight-bold text--darken-4">
          Patients Registered:
        </div>
        <hr class="green" />
        <br />
      </v-flex>
      <v-flex sm4>
        <stat-comp :header="month" :item="dash.MPCount"></stat-comp>
      </v-flex>
      <v-flex sm4>
        <stat-comp :header="year" :item="dash.YPCount"></stat-comp>
      </v-flex>
      <v-flex sm4>
        <stat-comp header="Total" :item="dash.OPCount"></stat-comp>
      </v-flex>
      <v-flex xs12 sm12 lg12>
        <br />
        <br />
        <div class="headline green--text font-weight-bold text--darken-4">
          Prescriptions Generated
        </div>
        <hr class="green" />
        <br />
      </v-flex>
      <v-flex sm4>
        <stat-comp :header="month" :item="dash.MPrCount"></stat-comp>
      </v-flex>
      <v-flex sm4>
        <stat-comp :header="year" :item="dash.YPrCount"></stat-comp>
      </v-flex>
      <v-flex sm4>
        <stat-comp header="Total" :item="dash.OPrCount"></stat-comp>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import WebH from "../api/web";
import StatComp from "../components/dashboard/Stat";
export default {
  components: {
    StatComp
  },
  data() {
    return {
      dash: {},
      month: "",
      year: ""
    };
  },
  created() {
    const d = new Date();
    //this.month = d.getMonth();
    this.month = d.toLocaleString("en-us", { month: "short" });
    this.year = d.getFullYear();
    this.api_get();
  },
  methods: {
    async api_get() {
      let url = "";
      if (this.$store.getters["UserStore/permissions"].includes("pata.v"))
        url = "/dashboard/dasha";
      else url = "/dashboard/dash";
      const res = await WebH.Get(url, "dashboard");
      if (res.Success) {
        this.dash = res.Data;
      }
    }
  }
};
</script>
